import cloneDeep from "lodash-es/cloneDeep"
import vuex from '../store'

export async function getTagOptions(): Promise<{ [key: string]: any }[]> {
  const userTagOption = {
    text: 'User',
    menu: [
      { text: 'Full Name', value: '{{user.name}}' },
      { text: 'First Name', value: '{{user.first_name}}' },
      { text: 'First Name (lower case)', value: '{{user.first_name_lower_case}}' },
      { text: 'Last Name', value: '{{user.last_name}}' },
      { text: 'Last Name (lower case)', value: '{{user.last_name_lower_case}}' },
      { text: 'Email', value: '{{user.email}}' },
      { text: 'Phone', value: '{{user.phone}}' },
      { text: 'Signature', value: '{{user.email_signature}}' },
      { text: 'Calendar Link', value: '{{user.calendar_link}}' },
      { text: 'Twilio Phone', value: '{{user.twilio_phone_number}}' },
      { text: 'Twilio Phone (raw format)', value: '{{user.twilio_phone_number_raw}}' }
    ],
  }

  const appointmentTagOption = {
    text: 'Appointment',
    menu: [
      { text: 'Start Date Time', value: '{{appointment.start_time}}' },
      { text: 'Start Date', value: '{{appointment.only_start_date}}' },
      { text: 'Start Time', value: '{{appointment.only_start_time}}' },
      { text: 'End Date Time', value: '{{appointment.end_time}}' },
      { text: 'End Date', value: '{{appointment.only_end_date}}' },
      { text: 'End Time', value: '{{appointment.only_end_time}}' },
      { text: 'Timezone', value: '{{appointment.timezone}}' },
      {
        text: 'Cancellation Link',
        value: '{{appointment.cancellation_link}}',
      },
      { text: 'Reschedule Link', value: '{{appointment.reschedule_link}}' },
      { text: 'Meeting Location', value: '{{appointment.meeting_location}}' },
      { text: 'Notes', value: '{{appointment.notes}}' },
      {
        text: 'Add to Google Calendar',
        value: '{{appointment.add_to_google_calendar}}',
      },
      {
        text: 'Add to iCal/Outlook',
        value: '{{appointment.add_to_ical_outlook}}',
      },
    ],
  }

  const appointmentUserTagOption = {
    text: 'User',
    menu: [
      { text: 'Full Name', value: '{{appointment.user.name}}' },
      { text: 'First Name', value: '{{appointment.user.first_name}}' },
      { text: 'Last Name', value: '{{appointment.user.last_name}}' },
      { text: 'Email', value: '{{appointment.user.email}}' },
      { text: 'Phone', value: '{{appointment.user.phone}}' },
      { text: 'Signature', value: '{{appointment.user.email_signature}}' },
      // { text: 'Calendar Link', value: '{{appointment.user.calendar_link}}' },
      {
        text: 'Twilio Phone',
        value: '{{appointment.user.twilio_phone_number}}',
      },
    ],
  }

  await vuex.dispatch('teams/syncAll')
  const calendarProvider = vuex.getters['teams/calendarProviders']
  if (calendarProvider && calendarProvider.length > 0) {
    appointmentTagOption.menu.push(appointmentUserTagOption)
  }

  const tagOptions = [
    {
      text: 'Contact',
      menu: [
        { text: 'Full Name', value: '{{contact.name}}' },
        { text: 'First Name', value: '{{contact.first_name}}' },
        { text: 'Last Name', value: '{{contact.last_name}}' },
        { text: 'Email', value: '{{contact.email}}' },
        { text: 'Phone', value: '{{contact.phone}}' },
        { text: 'Phone (raw format)', value: '{{contact.phone_raw}}' },
        { text: 'Company Name', value: '{{contact.company_name}}' },
        { text: 'Full Address', value: '{{contact.full_address}}' },
        { text: 'Address 1', value: '{{contact.address1}}' },
        { text: 'City', value: '{{contact.city}}' },
        { text: 'State', value: '{{contact.state}}' },
        { text: 'Country', value: '{{contact.country}}' },
        { text: 'Postal Code', value: '{{contact.postal_code}}' },
        { text: 'Date of birth', value: '{{contact.date_of_birth}}' },
        { text: 'Source', value: '{{contact.source}}' },
        { text: 'Website', value: '{{contact.website}}' },
        { text: 'ID', value: '{{contact.id}}' },
      ],
    },
    userTagOption,
    appointmentTagOption,
    {
      text: 'Calendar',
      menu: [{ text: 'Name', value: '{{calendar.name}}' }],
    },
    {
      text: 'Campaign',
      menu: [
        { text: 'Event Date & Time', value: '{{campaign.event_date_time}}' },
        { text: 'Event Date', value: '{{campaign.event_date}}' },
        { text: 'Event Time', value: '{{campaign.event_time}}' },
      ],
    },
    {
      text: 'Message',
      menu: [{ text: 'Message Body', value: '{{message.body}}' }],
    },
    {
      text: 'Account',
      menu: [
        { text: 'Name', value: '{{location.name}}' },
        { text: 'Full Address', value: '{{location.full_address}}' },
        { text: 'Address Line 1', value: '{{location.address}}' },
        { text: 'City', value: '{{location.city}}' },
        { text: 'State', value: '{{location.state}}' },
        { text: 'Country', value: '{{location.country}}' },
        { text: 'Postal Code', value: '{{location.postal_code}}' },
        { text: 'Email', value: '{{location.email}}' },
        { text: 'Phone', value: '{{location.phone}}' },
        { text: 'Website', value: '{{location.website}}' },
        { text: 'Logo URL', value: '{{location.logo_url}}' },
        {
          text: 'Owner',
          menu: [
            { text: 'First name', value: '{{location_owner.first_name}}' },
            { text: 'Last name', value: '{{location_owner.last_name}}' },
            { text: 'Email', value: '{{location_owner.email}}' },
          ],
        },
        { text: 'ID', value: '{{location.id}}' },
      ],
    },
    {
      text: 'Right now',
      menu: [
        { text: 'Second', value: '{{right_now.second}}' },
        { text: 'Minute', value: '{{right_now.minute}}' },
        { text: 'Hour 24h format', value: '{{right_now.hour}}' },
        { text: 'Hour AM/PM format', value: '{{right_now.hour_ampm}}' },
        { text: 'Time 24h format', value: '{{right_now.time}}' },
        { text: 'Time AM/PM format', value: '{{right_now.time_ampm}}' },
        { text: 'AM/PM', value: '{{right_now.ampm}}' },
        { text: 'Day', value: '{{right_now.day}}' },
        {
          text: 'Day of the week extended English',
          value: '{{right_now.day_of_week}}',
        },
        { text: 'Month', value: '{{right_now.month}}' },
        {
          text: 'Month extended English',
          value: '{{right_now.month_english}}',
        },
        { text: 'Year', value: '{{right_now.year}}' },
        {
          text: 'Date (month/day/year)',
          value: '{{right_now.middle_endian_date}}',
        },
        {
          text: 'Date (day/month/year)',
          value: '{{right_now.little_endian_date}}',
        },
      ],
    },
    {
      text: 'Attribution',
      menu: [
        {
          text: 'First',
          menu: [
            { text: 'Session Source', value: '{{ contact.attributionSource.sessionSource }}' },
            { text: 'URL', value: '{{ contact.attributionSource.url }}' },
            { text: 'Campaign', value: '{{ contact.attributionSource.campaign }}' },
            { text: 'UTM Source', value: '{{ contact.attributionSource.utmSource }}' },
            { text: 'UTM Medium', value: '{{ contact.attributionSource.utmMedium }}' },
            { text: 'UTM Content', value: '{{ contact.attributionSource.utmContent }}' },
            { text: 'Referrer', value: '{{ contact.attributionSource.referrer }}' },
            { text: 'Campaign Id', value: '{{ contact.attributionSource.campaignId }}' },
            { text: 'FB ClickId', value: '{{ contact.attributionSource.fbclid }}' },
            { text: 'Google ClickId', value: '{{ contact.attributionSource.gclid }}' },
          ]
        },
        {
          text: 'Latest',
          menu: [
            { text: 'Session Source', value: '{{ contact.lastAttributionSource.sessionSource }}' },
            { text: 'URL', value: '{{ contact.lastAttributionSource.url }}' },
            { text: 'Campaign', value: '{{ contact.lastAttributionSource.campaign }}' },
            { text: 'UTM Source', value: '{{ contact.lastAttributionSource.utmSource }}' },
            { text: 'UTM Medium', value: '{{ contact.lastAttributionSource.utmMedium }}' },
            { text: 'UTM Content', value: '{{ contact.lastAttributionSource.utmContent }}' },
            { text: 'Referrer', value: '{{ contact.lastAttributionSource.referrer }}' },
            { text: 'Campaign Id', value: '{{ contact.lastAttributionSource.campaignId }}' },
            { text: 'FB ClickId', value: '{{ contact.lastAttributionSource.fbclid }}' },
            { text: 'Google ClickId', value: '{{ contact.lastAttributionSource.gclid }}' },
          ]
        }
      ],
    },
    {
      text: 'Invoice',
      menu: [
        {
          text: "Company",
          menu: [
            {
              text: "Name",
              value: "{{ invoice.company.name }}"
            },
            {
              text: "Phone",
              value: "{{ invoice.company.phone }}"
            },
            {
              text: "Address",
              value: "{{ invoice.company.address }}"
            },
            {
              text: "City",
              value: "{{ invoice.company.city }}"
            },
            {
              text: "State",
              value: "{{ invoice.company.state }}"
            },
            {
              text: "Country",
              value: "{{ invoice.company.country }}"
            },
            {
              text: "Website",
              value: "{{ invoice.company.website }}"
            },
            {
              text: "Logo",
              value: "{{ invoice.company.logo }}"
            }
          ]
        },
        {
          text: "Customer",
          menu: [
            {
              text: "Name",
              value: "{{ invoice.customer.name }}"
            },
            {
              text: "First Name",
              value: "{{ invoice.customer.first_name }}"
            },
            {
              text: "Last Name",
              value: "{{ invoice.customer.last_name }}"
            },
            {
              text: "Phone",
              value: "{{ invoice.customer.phone }}"
            },
            {
              text: "Email",
              value: "{{ invoice.customer.email }}"
            },
            {
              text: "Company",
              value: "{{ invoice.customer.company }}"
            },
            {
              text: "Address",
              value: "{{ invoice.customer.address }}"
            },
            {
              text: "City",
              value: "{{ invoice.customer.city }}"
            },
            {
              text: "State",
              value: "{{ invoice.customer.state }}"
            },
            {
              text: "Postal code",
              value: "{{ invoice.customer.postal_code }}"
            }
          ]
        },
        {
          text: "Sender",
          menu: [
            {
              text: "Name",
              value: "{{ invoice.sender.name }}"
            },
            {
              text: "Email",
              value: "{{ invoice.customer.email }}"
            }
          ]
        },
        {
          text: "Name",
          value: "{{ invoice.name }}"
        },
        {
          text: "Number",
          value: "{{ invoice.number }}"
        },
        {
          text: "Issue Date",
          value: "{{ invoice.issue_date }}"
        },
        {
          text: "Due Date",
          value: "{{ invoice.due_date }}"
        },
        {
          text: "Sub Total",
          value: "{{ invoice.sub_total }}"
        },
        {
          text: "Discount Amount",
          value: "{{ invoice.discount_amount }}"
        },
        {
          text: "Tax Amount",
          value: "{{ invoice.tax_amount }}"
        },
        {
          text: "Total Amount",
          value: "{{ invoice.total_amount }}"
        },
        {
          text: "Title",
          value: "{{ invoice.title }}"
        },
        {
          text: "URL",
          value: "{{ invoice.url }}"
        },
        {
          text: "Card information",
          menu: [
            {
              text: "Card brand",
              value: "{{ invoice.card.brand }}"
            },
            {
              text: "Last 4",
              value: "{{ invoice.card.last4 }}"
            }
          ]
        }
      ],
    },
    {
      text: 'Documents & Contracts',
      menu: [
        {
          text: 'Name',
          value: '{{document.name}}',
        },
        {
          text: 'URL',
          value: '{{document.url}}',
        },
        {
          text: 'Type',
          value: '{{document.type}}',
        },
        {
          text: 'Total Amount',
          value: '{{document.totalAmount}}',
        },
        {
          text: 'Currency Code',
          value: '{{document.currencyCode}}',
        },
        {
          text: 'Currency Symbol',
          value: '{{document.currencySymbol}}',
        },
        {
          text: 'Expiry Date',
          value: '{{document.expirydate}}',
        },
        {
          text: 'Preview URL',
          value: '{{document.previewUrl}}',
        },
        {
          text: 'PDF URL',
          value: '{{document.pdfLink}}',
        },
        {
          text: 'Document Decline Reasons',
          value: '{{document.declinedReasons}}',
        },
        {
          text: 'Document Decline Reason Body',
          value: '{{document.declinedReasonBody}}',
        },
        {
          text: 'Recipient',
          menu: [
            {
              text: 'First Name',
              value: '{{document.recipient.firstName}}',
            },
            {
              text: 'Last Name',
              value: '{{document.recipient.lastName}}',
            },
            {
              text: 'Email',
              value: '{{document.recipient.email}}',
            },
            {
              text: 'Phone',
              value: '{{document.recipient.phoneNumber}}',
            },
            {
              text: 'Country',
              value: '{{document.recipient.country}}',
            },
          ],
        },
      ]
    },
    {
      text: 'Estimate',
      menu: [
        {
          text: "Company",
          menu: [
            {
              text: "Name",
              value: "{{ estimate.company.name }}"
            },
            {
              text: "Phone",
              value: "{{ estimate.company.phone }}"
            },
            {
              text: "Address",
              value: "{{ estimate.company.address }}"
            },
            {
              text: "City",
              value: "{{ estimate.company.city }}"
            },
            {
              text: "State",
              value: "{{ estimate.company.state }}"
            },
            {
              text: "Country",
              value: "{{ estimate.company.country }}"
            },
            {
              text: "Website",
              value: "{{ estimate.company.website }}"
            },
            {
              text: "Logo",
              value: "{{ estimate.company.logo }}"
            }
          ]
        },
        {
          text: "Customer",
          menu: [
            {
              text: "Name",
              value: "{{ estimate.customer.name }}"
            },
            {
              text: "First Name",
              value: "{{ estimate.customer.first_name }}"
            },
            {
              text: "Last Name",
              value: "{{ estimate.customer.last_name }}"
            },
            {
              text: "Phone",
              value: "{{ estimate.customer.phone }}"
            },
            {
              text: "Email",
              value: "{{ estimate.customer.email }}"
            },
            {
              text: "Address",
              value: "{{ estimate.customer.address }}"
            },
            {
              text: "City",
              value: "{{ estimate.customer.city }}"
            },
            {
              text: "State",
              value: "{{ estimate.customer.state }}"
            },
            {
              text: "Postal code",
              value: "{{ estimate.customer.postal_code }}"
            }
          ]
        },
        {
          text: "Sender",
          menu: [
            {
              text: "Name",
              value: "{{ estimate.sender.name }}"
            },
            {
              text: "Email",
              value: "{{ estimate.sender.email }}"
            }
          ]
        },
        {
          text: "Name",
          value: "{{ estimate.name }}"
        },
        {
          text: "Number",
          value: "{{ estimate.number }}"
        },
        {
          text: "Issue Date",
          value: "{{ estimate.issue_date }}"
        },
        {
          text: "Expiry Date",
          value: "{{ estimate.expiry_date }}"
        },
        {
          text: "Sub Total",
          value: "{{ estimate.sub_total }}"
        },
        {
          text: "Discount Amount",
          value: "{{ estimate.discount_amount }}"
        },
        {
          text: "Tax Amount",
          value: "{{ estimate.tax_amount }}"
        },
        {
          text: "Total Amount",
          value: "{{ estimate.total_amount }}"
        },
        {
          text: "Title",
          value: "{{ estimate.title }}"
        },
        {
          text: "URL",
          value: "{{ estimate.url }}"
        },
      ],
    },
    {
      text: 'Payment Link',
      menu: [
        {
          text: "Name",
          value: "{{ paymentLink.link_name }}"
        },
        {
          text: "Url",
          value: "{{ paymentLink.url }}"
        },
        {
          text: "Account Name",
          value: "{{paymentLink.account_name}}"
        },
        {
          text: "Sender Name",
          value: "{{ paymentLink.sender_name }}"
        },
        {
          text: "Sender Email",
          value: "{{ paymentLink.sender_email }}"
        },
        {
          text: "Total Amount",
          value: "{{ paymentLink.total_amount }}"
        },
        {
          text: "Total After Trial",
          value: "{{ paymentLink.total_after_trial }}"
        },
        {
          text: "Contact",
          menu: [
            {
              text: "First Name",
              value: "{{ paymentLink.contact.first_name }}"
            },
            {
              text: "Last Name",
              value: "{{ paymentLink.contact.last_name }}"
            },
            {
              text: "Phone",
              value: "{{ paymentLink.contact.phone }}"
            },
            {
              text: "Email",
              value: "{{ paymentLink.contact.email }}"
            },
            {
              text: "Address",
              value: "{{ paymentLink.contact.address }}"
            },
            {
              text: "City",
              value: "{{ paymentLink.contact.city }}"
            },
            {
              text: "State",
              value: "{{ paymentLink.contact.state }}"
            },
            {
              text: "Postal code",
              value: "{{ paymentLink.contact.postal_code }}"
            }
          ]
        },
        {
          text: "Sender",
          menu: [
            {
              text: "Name",
              value: "{{ paymentLink.sender.name }}"
            },
            {
              text: "Email",
              value: "{{ paymentLink.sender.email }}"
            }
          ]
        },
        {
          text: "Product",
          menu: [
            {
              text: "Name",
              value: "{{paymentLink.product.name}}"
            },
            {
              text: "Currency Symbol",
              value: "{{ paymentLink.product.currency_symbol }}"
            },
            {
              text: "Currency Code",
              value: "{{ paymentLink.product.currency_code }}"
            },
            {
              text: "Image Url",
              value: "{{ paymentLink.product.imageUrl }}"
            },
            {
              text: "Trial Period",
              value: "{{ paymentLink.product.trial_period }}"
            },
          ]
        }
      ]
    },
    {
      text: 'Client Portal Contact',
      menu: [
        {
          text: "Login URL(Magic Link)",
          value: "{{ membership_contact.login_url }}"
        },
      ],
    }
  ]

  return cloneDeep(tagOptions)
}

export function getTaskOptions(): { [key: string]: any }[] {
  return [
    {
      text: 'Task',
      menu: [
        { text: 'Title', value: '{{task.title}}' },
        { text: 'Description', value: '{{task.body}}' },
        { text: 'Due Date', value: '{{task.dueDate}}' },
      ],
    },
  ]
}

export function getFormOptions(): { [key: string]: any }[] {
  return [
    {
      text: 'Form',
      menu: [
        { text: 'Full Name', value: '{{form_data.full_name}}' },
        { text: 'First Name', value: '{{form_data.first_name}}' },
        { text: 'Last Name', value: '{{form_data.last_name}}' },
        { text: 'Email', value: '{{form_data.email}}' },
        { text: 'Phone', value: '{{form_data.phone}}' },
        { text: 'Organization', value: '{{form_data.organization}}' },
        { text: 'Address 1', value: '{{form_data.address}}' },
        { text: 'City', value: '{{form_data.city}}' },
        { text: 'State', value: '{{form_data.state}}' },
        { text: 'Postal Code', value: '{{form_data.postal_code}}' },
        { text: 'Date of birth', value: '{{form_data.date_of_birth}}' },
        { text: 'Website', value: '{{form_data.website}}' },
        { text: 'Source', value: '{{form_data.source}}' },
      ],
    },
  ]
}

export function getSurveyOptions(): { [key: string]: any }[] {
  return [
    {
      text: 'Survey',
      menu: [
        { text: 'Full Name', value: '{{survey_data.full_name}}' },
        { text: 'First Name', value: '{{survey_data.first_name}}' },
        { text: 'Last Name', value: '{{survey_data.last_name}}' },
        { text: 'Email', value: '{{survey_data.email}}' },
        { text: 'Phone', value: '{{survey_data.phone}}' },
        { text: 'Organization', value: '{{survey_data.organization}}' },
        { text: 'Address 1', value: '{{survey_data.address}}' },
        { text: 'City', value: '{{survey_data.city}}' },
        { text: 'State', value: '{{survey_data.state}}' },
        { text: 'Postal Code', value: '{{survey_data.postal_code}}' },
        { text: 'Date of birth', value: '{{survey_data.date_of_birth}}' },
        { text: 'Source', value: '{{survey_data.source}}' },
      ],
    },
  ]
}

export function getAppointmentOptions(): { [key: string]: any }[] {
  return [
    {
      text: 'Appointment',
      menu: [
        { text: 'Start Date Time', value: '{{appointment.start_time}}' },
        { text: 'Start Date', value: '{{appointment.only_start_date}}' },
        { text: 'Start Time', value: '{{appointment.only_start_time}}' },
        { text: 'End Date Time', value: '{{appointment.end_time}}' },
        { text: 'End Date', value: '{{appointment.only_end_date}}' },
        { text: 'End Time', value: '{{appointment.only_end_time}}' },
        { text: 'Timezone', value: '{{appointment.timezone}}' },
        {
          text: 'Cancellation Link',
          value: '{{appointment.cancellation_link}}',
        },
        { text: 'Reschedule Link', value: '{{appointment.reschedule_link}}' },
        { text: 'Meeting Location', value: '{{appointment.meeting_location}}' },
        { text: 'Notes', value: '{{appointment.notes}}' },
        {
          text: 'Add to Google Calendar',
          value: '{{appointment.add_to_google_calendar}}',
        },
        {
          text: 'Add to iCal/Outlook',
          value: '{{appointment.add_to_ical_outlook}}',
        },
      ],
    },
  ]
}

export function getContactCredentials(): { [key: string]: any }[] {
  return [
    {
      text: 'Membership login',
      menu: [{ text: 'Password', value: '{{membership_contact.password}}' }],
    },
  ]
}

export function getMembershipLoginURL(): { [key: string]: any }[] {
  return [
    {
      text: 'Membership Offer Details',
      menu: [
        { text: 'Email', value: '{{membership_contact.email}}' },
        { text: 'Login URL', value: '{{membership_contact.login_url}}' },
      ],
    },
  ]
}
